import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { DatePicker, TreeSelect, Card, Tabs, Button, Row, Alert, Space, Divider } from 'antd';
import { ReloadOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _ from 'lodash';
import qs from 'qs';
import { Form } from '@ant-design/compatible';
import CustomerScheduleDetail from '@/routes/customer-schedule/CustomerScheduleDetail';
import { checkPermission } from '@/utils/permission';
import { cleanObject, makeTree, isValidDate, CustomerScheduleType, CustomerScheduleNaStatus, CustomerScheduleStatus, CustomerScheduleTeleStatus, formatNumber } from '@/utils/helpers';
import HtmlParser from 'react-html-parser';
import BaseSelect from '@/components/Elements/BaseSelect';
import html2canvas from 'html2canvas';
import moment from 'moment';
import { getListDoctorAppointments } from '@/redux/actions/doctorAppointmentActions';
import DynamicTable from '@/components/DynamicTable';
import FilterableMultiSelect from '@/components/FilterableMultiSelect';
import { Helmet } from 'react-helmet';
import CustomerInfoColumn from '@/components/customers/CustomerInfoColumn';
import ScheduleStatusButton from '@/components/ScheduleStatusButton';
import ScheduleTimeCell from '@/components/ScheduleTimeCell';
import { fetchFilters } from '@/redux/actions/filterActions';
import { getSpecificCustomerSchedule } from '@/redux/actions/CustomerScheduleActions';

const { RangePicker } = DatePicker;

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/doctor-appointments',
        breadcrumbName: 'Lịch hẹn khám',
    },
]
const { TabPane } = Tabs;

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isOpenDetail: false,
            currentData: null,
            loadingCapture: false,
            current_id: null
        }

        this.tableRef = createRef();
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.loadData(query);
        this.props.fetchFilters();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.loadData(query);
        }
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        if (name === 'created_at') {
            if (value && value.length > 0) {
                query.created_date_start = moment(value[0]).format('YYYY-MM-DD');
                query.created_date_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.created_date_start;
                delete query.created_date_end;
            }
        }
        if (name === 'appointment_schedule') {
            if (value && value.length > 0) {
                query.appointment_schedule_start = moment(value[0]).format('YYYY-MM-DD');
                query.appointment_schedule_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.appointment_schedule_start;
                delete query.appointment_schedule_end;
            }
        }
        delete query.created_at;
        delete query.appointment_schedule;
        delete query.schedule_consultation;
        query = cleanObject(query);
        //console.log("query: ", query)
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentData: data });
    }

    onDetail(id) {
        this.setState({ current_id: id })
        this.props.getSpecificCustomerSchedule(id).then(res => {
            console.log('sdberhe', res)
            //console.log(res)
            this.toggleOpenDetail(true, res);
        })
    }

    loadData(query) {
        this.setState({ isLoading: true });
        this.props.getListDoctorAppointments(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    onCancel() {
        this.props.form.resetFields();
        this.setState({ isOpenDetail: false });
    }

    handleCaptureClick = async () => {
        this.setState({ loadingCapture: true });

        const table = this.tableRef.current;
        if (!table) return;

        // Tạo một bảng tạm thời với kích thước lớn
        const clonedTable = table.cloneNode(true);
        clonedTable.style.width = 'max-content';
        clonedTable.style.height = 'max-content';

        // Thêm bảng tạm thời vào body để tránh các ràng buộc CSS
        document.body.appendChild(clonedTable);

        // Chụp ảnh của bảng tạm thời
        await html2canvas(clonedTable).then(canvas => {
            // Chuyển canvas thành hình ảnh và tải xuống
            const imgData = canvas.toDataURL('image/jpg');
            const link = document.createElement('a');
            const d = new Date();
            const f = (n) => (`0${n}`).slice(-2);
            link.href = imgData;
            link.download = `lich-hen-${[f(d.getDate()), f(d.getMonth() + 1), d.getFullYear(), f(d.getHours()), f(d.getMinutes())].join('-')}.jpg`;
            link.click();

            // Loại bỏ bảng tạm thời sau khi đã chụp ảnh
            document.body.removeChild(clonedTable);
        });
        this.setState({ loadingCapture: false });
    };

    render() {
        var { pagination, users, doctors, statistics, filterData, appointments } = this.props;
        var { isLoading, isOpenDetail,
            currentData, current_id,
            loadingCapture,
        } = this.state;

        var query = qs.parse(this.props.location.search.slice(1));

        // Helmet được chèn vào đây
        const pageTitle = 'LỊCH HẸN - CHINGO DENTAL';

        const customer_source_active_list = filterData?.sources;
        const branchActiveList = filterData?.branches;
        const service_active_list = filterData?.services;

        const service = makeTree(service_active_list || [], 0);

        const columns = [
            {
                title: 'STT',
                align: 'center',
                width: '50px',
                dataIndex: 'stt',
                key: 'stt',
                render: (text, record, index) => {
                    return index + 1;
                }
            },
            {
                title: 'Giờ',
                dataIndex: 'time_to',
                key: 'time_to',
                width: '180px',
                render: (_, record) => (
                    <ScheduleTimeCell record={record} />
                )
            },
            {
                title: 'Khách hàng',
                key: 'customer',
                width: 300,
                render: (_, record) => {
                    const customer = {
                        id: record?.customer?.id,
                        code: record?.customer?.code,
                        full_name: record?.customer?.full_name,
                        branch_name: record?.customer?.branche?.name,
                        conditions: record?.customer?.conditions,
                        customer_source: record?.customer?.customer_source?.name,
                        customer_status: record?.customer?.customer_status?.name,
                        customer_status_color: record?.customer?.customer_status?.text_color,
                        medical_book_number: record?.customer?.medical_book_number
                    }
                    return (
                        <CustomerInfoColumn
                            record={customer}
                            nameField="full_name"
                            idField="id"
                            codeField="code"
                            branchField="branch_name"
                            medicalBookField="medical_book_number"
                            conditionField="conditions"
                            enableLink={true}
                            sourceField="customer_source"
                        />
                    )
                }
            },
            {
                title: 'Ngày sinh',
                dataIndex: 'customer_birthday',
                key: 'customer_birthday',
                width: 120,
                render: (text, record) => {
                    if (!text) return <span style={{ color: '#bfbfbf' }}>—</span>;

                    const birthDate = moment(text);
                    const isValid = birthDate.isValid();
                    if (!isValid) return <span style={{ color: '#bfbfbf' }}>—</span>;

                    const age = record.customer_age;
                    const formattedDate = isValidDate(record.customer_birthday, false);

                    return (
                        <div style={{ lineHeight: 1.3 }}>
                            <div style={{ fontWeight: 500, color: '#222' }}>
                                {formattedDate}
                            </div>
                            {age && (
                                <div style={{ fontSize: 14, color: '#8c8c8c', marginTop: 2 }}>
                                    {age} tuổi
                                </div>
                            )}
                        </div>
                    );
                },
            },
            {
                title: 'Phụ trách buổi hẹn',
                dataIndex: 'doctors',
                key: 'doctors',
                width: '250px',
                render: (text, record) => {
                    const doctors = record.doctors || [];
                    const assistants = record.assistants || [];
                    return (
                        <>
                            <div>
                                {doctors.map((staff) => (
                                    <div key={staff.id}>
                                        <span style={{ color: "#999" }}>
                                            {staff.user_role?.name || ""}:{' '}
                                        </span>
                                        <span style={{ fontWeight: 600 }}>
                                            {staff.full_name}
                                        </span>
                                    </div>
                                ))}
                            </div>
                            <div style={{ marginTop: 3 }}>
                                {assistants.map((staff) => (
                                    <div key={staff.id}>
                                        <span style={{ color: "#999" }}>
                                            {staff.user_role?.name || ""}:{' '}
                                        </span>
                                        <span style={{ fontWeight: 600 }}>
                                            {staff.full_name}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </>
                    )
                }
            },
            {
                title: 'Trạng thái',
                dataIndex: 'status',
                key: 'status',
                width: '100px',
                render: (_, record) => (
                    <ScheduleStatusButton
                        record={record}
                    />
                )
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '250px',
                render: (text, record) => {
                    //return (<ExpandableText text={text} rows={1} />)
                    return (<>{HtmlParser(text)}</>)
                }
            },
            {
                title: 'Actions',
                align: 'center',
                width: '250px',
                dataIndex: 'actions',
                key: 'actions',
                render: (text, record) => {
                    return (
                        <Space>
                            <Button
                                type="primary"
                                size='small'
                                disabled={!checkPermission('customer_schedule', 'detail')}
                                icon={<EyeOutlined />}
                                onClick={() => this.onDetail(record.id, record.customer_id)}
                            >
                                Xem chi tiết
                            </Button>
                        </Space>
                    );
                }
            }

        ];

        const tables = <DynamicTable
            dataSource={appointments || []}
            columns={columns}
            isLoading={isLoading}
            pagination={pagination}
            rowSelection={false}
            ref={this.tableRef}
            moduleKey="customer_schedule2"
            onChangeTable={(pagination, sorter) => this.onChangeTable(pagination, sorter)}
            getRowStyle={(record) => {
                const colorMap = {
                    dangcho: '#aac41a19',       // vàng nhạt
                    dangtrongca: '#188fff2e', // xanh nước biển nhạt
                    daden: '#aac41a19',      // xanh lá nhạt
                    daxong: '#53c41a19',      // xanh lá nhạt
                    dagoi: '#53c41a19',      // xanh lá nhạt
                    dahuy: '#ff7f5023',       // cam nhạt
                    chuaden: '#fff',       // vàng cam nhạt
                };
                return record.status && colorMap[record.status]
                    ? { backgroundColor: colorMap[record.status] }
                    : {};
            }}
            className="no-hover-table"
        />

        return (
            <div>
                <Helmet>
                    <title>{pageTitle}</title>
                </Helmet>
                <PageTitle routes={routes} title="Lịch hẹn khám" />
                <div>
                    <TableActionBar
                        isShowAddButton={false}
                        isShowDeleteButton={false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        placeholderSearch="Mã, tên, 3 số cuối sđt của khách hàng"
                        activeFilter={
                            query.name ||
                            query.status ||
                            query.branch_id ||
                            query.branch_service_id ||
                            query.service_id ||
                            query.sales_staff ||
                            query.doctor_id ||
                            query.customer_source_id ||
                            query.appointment_schedule_start
                        }
                        filters={
                            [
                                <BaseSelect
                                    options={CustomerScheduleType || []}
                                    placeholder="Kiểu lịch hẹn"
                                    defaultValue={query.name ? query.name : null}
                                    onChange={(value) => this.onChangeFilter('name', value)}
                                    className="w-100"
                                />,
                                <BaseSelect
                                    options={branchActiveList || []}
                                    optionValue="id"
                                    optionLabel="name"
                                    placeholder="Chọn cơ sở"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('branch_id', value)}
                                    defaultValue={query.branch_id ? parseInt(query.branch_id) : null}
                                />,
                                <BaseSelect
                                    options={branchActiveList || []}
                                    optionValue="id"
                                    optionLabel="name"
                                    placeholder="Chọn cơ sở thực hiện"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('branch_service_id', value)}
                                    defaultValue={query.branch_service_id ? parseInt(query.branch_service_id) : null}
                                />,
                                <BaseSelect
                                    options={CustomerScheduleStatus.concat(CustomerScheduleTeleStatus).concat(CustomerScheduleNaStatus)}
                                    placeholder="Trạng thái"
                                    className="w-100"
                                    defaultValue={query.status ? query.status : null}
                                    onChange={(value) => this.onChangeFilter('status', value)}
                                />,
                                <TreeSelect
                                    showSearch
                                    className="w-100"
                                    dropdownStyle={{ maxHeight: 450, overflow: 'auto' }}
                                    treeData={service}
                                    treeNodeFilterProp='title'
                                    allowClear
                                    placeholder="Dịch vụ"
                                    treeDefaultExpandAll
                                    defaultValue={query.service_id ? parseInt(query.service_id) : null}
                                    onChange={(value) => this.onChangeFilter('service_id', value)}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Nhân viên chốt"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('sales_staff', value)}
                                    defaultValue={query.sales_staff ? parseInt(query.sales_staff) : null}
                                />,
                                <BaseSelect
                                    options={doctors || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Bác sĩ thực hiện"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('doctor_id', value)}
                                    defaultValue={query.doctor_id ? parseInt(query.doctor_id) : null}
                                />,
                                <FilterableMultiSelect
                                    options={customer_source_active_list || []}
                                    placeholder="Nguồn khách hàng"
                                    parameterName='customer_source_id'
                                    optionValue="id"
                                    optionLabel="name"
                                />
                            ]
                        }
                    >
                        <RangePicker
                            format="DD/MM/YYYY"
                            placeholder={['Từ ngày', 'Đến ngày']}
                            style={{ width: 250 }}
                            onChange={(value) => this.onChangeFilter('appointment_schedule', value)}
                            className='table-button'
                            defaultValue={[
                                query.appointment_schedule_start
                                    ? moment(query.appointment_schedule_start, 'YYYY-MM-DD')
                                    : moment(), // mặc định ngày hiện tại
                                query.appointment_schedule_end
                                    ? moment(query.appointment_schedule_end, 'YYYY-MM-DD')
                                    : moment()  // mặc định ngày hiện tại
                            ]}
                        />
                        <Button className="table-button" type='primary' icon={<DownloadOutlined />} loading={loadingCapture} onClick={() => this.handleCaptureClick()}>Chụp màn hình</Button>
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>
                    </TableActionBar>
                </div>

                <Row gutter={16} className="mb-2" justify="space-between" style={{ margin: 0 }}>
                    <Card size='small' className="appointment-card w-100">
                        <div className="stats-row">
                            <span className="statistic-label">
                                Tổng số lịch hẹn: <span className="value total">{formatNumber(statistics?.total || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Lịch tư vấn: <span className="value consultant">{formatNumber(statistics?.name?.TUVAN || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Lịch điều trị: <span className="value treatment">{formatNumber(statistics?.name?.LAMDICHVU || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Lịch tái khám: <span className="value recheck">{formatNumber(statistics?.name?.TAIKHAM || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Lịch gọi lại: <span className="value recall">{formatNumber(statistics?.name?.GOILAI || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Hủy lịch: <span className="value danger">{formatNumber(statistics?.status?.dahuy || 0)}</span>
                            </span>
                        </div>

                        <div className="stats-row">
                            <span className="statistic-label">
                                Đã đến: <span className="value arrived">{formatNumber(statistics?.arrived_total || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Chưa đến: <span className="value notarrived">{formatNumber(statistics?.status?.chuaden || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Đang chờ: <span className="value waiting">{formatNumber(statistics?.status?.dangcho || statistics?.status?.daden || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Đang trong ca: <span className="value inprogress">{formatNumber(statistics?.status?.dangtrongca || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Đã xong: <span className="value completed">{formatNumber(statistics?.status?.daxong || 0)}</span>
                            </span>
                            <span className="statistic-label">&nbsp;</span>
                        </div>
                        <Divider style={{ margin: '8px 0' }} />
                        <div className="stats-row" style={{ marginBottom: 0 }}>
                            <span className="statistic-label" style={{ display: 'block' }}>
                                Bác sĩ đang trong ca ({statistics?.doctor_in_progress_total || 0}): <span className="doctor_inprogress">{statistics?.doctor_in_progress || ''}</span>
                            </span>
                            <span className="statistic-label" style={{ display: 'block' }}>
                                Bác sĩ ngoài ca ({statistics?.doctor_available_total || 0}): <span className="doctor_available">{statistics?.doctor_available || ''}</span>
                            </span>
                        </div>
                    </Card>
                </Row>

                <Card size='small' bodyStyle={{ padding: 0 }} className='has-custom-column-table-btn'>
                    <Tabs onChange={(value) => this.onChangeFilter('tab', value)} defaultActiveKey={query.tab} type="card" size="small">
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch hẹn hôm nay</span>} key="1">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch hẹn ngày mai</span>} key="2">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch hẹn hôm qua</span>} key="4">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch chưa xác định</span>} key="5">
                            <div ref={this.tableRef}>
                                <Alert
                                    style={{ border: 'none' }}
                                    message="Danh sách các khách hàng chưa hẹn được cụ thể lịch hẹn tiếp theo, cần chú ý liên hệ chăm sóc lại thường xuyên."
                                    type="warning"
                                />
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch chưa đến, chưa gọi</span>} key="6">
                            <div ref={this.tableRef}>
                                <Alert
                                    style={{ border: 'none' }}
                                    message="Danh sách khách hàng đã có lịch hẹn nhưng chưa đến (hoặc chưa gọi lại cho khách), cần gọi lại để hẹn lịch mới hàng ngày."
                                    type="warning"
                                />
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Tất cả lịch hẹn</span>} key="3">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                    </Tabs>
                </Card>

                <CustomerScheduleDetail
                    visible={isOpenDetail}
                    currentItem={currentData}
                    reloadData2={() => this.loadData(query)}
                    reloadData={() => this.onDetail(current_id)}
                    onCancel={() => this.toggleOpenDetail(false)}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        appointments: state.doctorAppointmentReducer.list.data,
        pagination: state.doctorAppointmentReducer.list.pagination,
        statistics: state.doctorAppointmentReducer.statistics,
        users: state.config.users,
        doctors: state.config.doctors,
        filterData: state.filterReducer.list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListDoctorAppointments: (filter) => dispatch(getListDoctorAppointments(filter)),
        getSpecificCustomerSchedule: (id) => dispatch(getSpecificCustomerSchedule(id)),
        fetchFilters: () => dispatch(fetchFilters()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'doctor_appointments' })(Index));

